import { isAxiosError } from 'axios';
import {
  UnpaidReportOrders,
  UnpaidReportOrdersCode,
} from '../types/unpaidReportOrders.types';

/**
 * The unpaid report orders behind a 409, or null for any other failure.
 * Recognised by `code`, never by the message, which is copy and may change.
 */
export const readUnpaidReportOrders = (
  error: unknown
): UnpaidReportOrders | null => {
  if (!isAxiosError(error) || error.response?.status !== 409) return null;
  const body = error.response.data;
  const codes: string[] = Object.values(UnpaidReportOrdersCode);
  if (!body || !codes.includes(body.code) || !body.data) return null;
  return {
    code: body.code,
    message: body.message,
    count: body.data.count,
    subTotal: body.data.subTotal,
    clientGets: body.data.clientGets,
    orders: body.data.orders ?? [],
  };
};

/** `1 order hasn't been paid yet`, `2 orders haven't been paid yet`. */
export const unpaidReportOrdersTitle = (count: number) =>
  count === 1
    ? "1 order hasn't been paid yet"
    : `${count} orders haven't been paid yet`;
